import React, { useState, useEffect } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { forgot_password, reset_password } from '../../../../api/API';


const useStyles = makeStyles(theme => ({
    root: {},

    fields: {
        margin: theme.spacing(-1),
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            flexGrow: 1,
            margin: theme.spacing(1)
        }

    },

    submitButton: {
        marginTop: theme.spacing(2),
        width: '100%',

        "&:hover": {
            background: "#CECAC1"
        },
    }

}));

export default function Form(props) {
    const { className, ...rest } = props;
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const classes = useStyles();
    const history = useHistory();
    const token = "";
    console.log(props);
    // const router = useRouter();
    // const dispatch = useDispatch();

    const [values, setValues] = useState({
        password: "",
        password2: "",
        token: props.token
    });



    const handleSubmit = async event => {

        event.preventDefault();
        if (values.password == "" || values.password2 == "") {
            alert("Please fill in all the fields");
            return;
        }
        if (values.password != values.password2) {
            alert("Passwords do not match");
            return;
        }

        let data = await reset_password({
            password: values.password,
            token: props.token
        });
        if (data) {
            alert("Successfully updated");
            window.location.href = "/";
        } else {
            alert("Invalid link");
        }

        // });
    };


    return (
        <form
            {...rest}
            className={clsx(classes.root, className)}
            onSubmit={handleSubmit}
        >
            <div className={classes.fields}>

                <TextField
                    type="password"
                    fullWidth
                    label="Password"
                    name="password"
                    required={true}
                    onChange={(e) => {
                        setValues({
                            ...values,
                            password: e.target.value
                        })
                    }}
                    value={values.password}
                    variant="outlined"
                />


            </div>
            <div className={classes.fields}>

                <TextField
                    type="password"
                    fullWidth
                    label="Confirm Password"
                    name="password2"
                    required={true}
                    onChange={(e) => {
                        setValues({
                            ...values,
                            password2: e.target.value
                        })
                    }}
                    value={values.password2}
                    variant="outlined"
                />


            </div>
            {
                !hasSubmitted && (<Button
                    className={classes.submitButton}
                    color="secondary"
                    size="large"
                    type="submit"
                    variant="contained"
                >
                    CONFIRM
                </Button>)
            }

        </form>
    );
}
